export default __webpack_public_path__ + "images/a12eae64a6db38d6cb30a86f9da45d56.png";